"use strict";

exports.__esModule = true;
exports["default"] = createSourceConnector;

function createSourceConnector(backend) {
  return {
    dragSource: function connectDragSource() {
      return backend.connectDragSource.apply(backend, arguments);
    },
    dragPreview: function connectDragPreview() {
      return backend.connectDragPreview.apply(backend, arguments);
    }
  };
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dnd/lib/createSourceConnector.js
 ** module id = 246
 ** module chunks = 1
 **/